import { j as o } from "../../../jsx-runtime-B6kdoens.js";
import { c as A } from "../../../index-CROKJrb5.js";
import { c as f, f as x } from "../../../create-component-CBAeEoQ6.js";
import { useAccordionStateAtoms as y } from "../AccordionState/index.js";
import { M as C } from "../../../motion-jk0ivqSc.js";
import { m as j } from "../../../motion-minimal-Crg_qVxv.js";
import { u as t } from "../../../react-B_GApDuV.js";
import { A as h } from "../../../index-LYq8AemS.js";
const v = {
  initial: { opacity: 0 },
  animate: {
    opacity: 1,
    transition: {
      opacity: {
        duration: 0.1,
        delay: 0.2
      }
    }
  },
  exit: {
    opacity: 0,
    transition: {
      opacity: {
        duration: 0.1
      }
    }
  },
  transition: { ease: "easeInOut" }
}, b = A({
  base: "cur-overflow-hidden",
  variants: {
    size: {
      md: "cur-mt-1",
      lg: "cur-mt-2"
    }
  }
}), O = f(
  "AccordionContent",
  x(
    ({ as: i, children: e, className: r, ...s }, a) => {
      const c = i || j.div, { openAtom: m, sizeAtom: p, idAtom: d } = y(), n = t(d), l = t(m), u = t(p);
      return /* @__PURE__ */ o.jsx(C, { children: /* @__PURE__ */ o.jsx(h, { children: l ? /* @__PURE__ */ o.jsx(
        c,
        {
          ...v,
          id: `content-${n}`,
          ref: a,
          className: b({ className: r, size: u }),
          role: "region",
          "aria-labelledby": n,
          ...s,
          children: e
        },
        "test"
      ) : null }) });
    }
  )
);
export {
  O as AccordionContent
};
//# sourceMappingURL=index.js.map
